import React from 'react';
import styles from './colorDot.module.scss';

const ColorDot = ({ color }) => <div className={styles['color-dot']} style={{ backgroundColor: color }} />;

export default ColorDot;
